import React, { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button, { LinkButton } from '@atlaskit/button/new';
import { Box, xcss } from '@atlaskit/primitives';
import GlobalOptInDefaultImageBanner from '../../../assets/global-opt-in-default-image-banner.svg';
import { ADMIN_LINK, AI_LINK } from '../../../common/constants';
import { messages } from '../../../messages';
import { BodyWrapper, ButtonContainer, ContentContainer, HeaderWrapper, ImageWrapper, OptInBackgroundBorder, OptInContainer } from './styled';
var VisibleTextOrgAdminStyles = xcss({
  color: 'color.text.subtlest',
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
var AiOptIn = function AiOptIn(_ref) {
  var source = _ref.source,
    product = _ref.product,
    isOrgAdmin = _ref.isOrgAdmin,
    image = _ref.image,
    headerText = _ref.headerText,
    bodyText = _ref.bodyText,
    width = _ref.width,
    testId = _ref.testId,
    onAdminCTA = _ref.onAdminCTA,
    onAdminClose = _ref.onAdminClose,
    adminBodyText = _ref.adminBodyText,
    adminHeaderText = _ref.adminHeaderText,
    adminCTAText = _ref.adminCTAText,
    adminCloseCTAText = _ref.adminCloseCTAText,
    adminLink = _ref.adminLink;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var onLearnMoreClicked = function onLearnMoreClicked(e) {
    e.stopPropagation();
    createAnalyticsEvent({
      type: 'sendUIEvent',
      data: {
        source: source,
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
        attributes: {
          product: product,
          isOrgAdmin: !!isOrgAdmin
        },
        tags: ['fabricElements']
      }
    }).fire();
  };
  var formatMessageValues = {
    a: function a(s) {
      return /*#__PURE__*/React.createElement("a", {
        href: AI_LINK,
        target: "_blank",
        onClick: onLearnMoreClicked
      }, s);
    },
    br: function br() {
      return /*#__PURE__*/React.createElement("br", null);
    }
  };
  var defaultHeader = formatMessage(messages.aiOptInDialogHeaderText);
  var header = headerText !== null && headerText !== void 0 ? headerText : defaultHeader;
  var body = bodyText !== null && bodyText !== void 0 ? bodyText : formatMessage(messages.aiOptInDialogBodyText, formatMessageValues);
  var orgAdminBody = adminBodyText !== null && adminBodyText !== void 0 ? adminBodyText : formatMessage(messages.aiOptInDialogAdminBodyText, formatMessageValues);
  var orgAdminHeader = adminHeaderText !== null && adminHeaderText !== void 0 ? adminHeaderText : defaultHeader;
  useEffect(function () {
    var preloadImages = function preloadImages(paths) {
      paths.forEach(function (path) {
        var img = new Image();
        img.src = path;
      });
    };
    preloadImages([GlobalOptInDefaultImageBanner]);
  }, []);
  useEffect(function () {
    createAnalyticsEvent({
      type: 'sendScreenEvent',
      data: {
        name: 'aiGlobalOptInDialog',
        attributes: {
          source: source,
          product: product,
          isOrgAdmin: !!isOrgAdmin
        },
        tags: ['fabricElements']
      }
    }).fire();
  }, [createAnalyticsEvent, source, product, isOrgAdmin]);
  var onCloseClicked = function onCloseClicked(e) {
    e.stopPropagation();
    onAdminClose === null || onAdminClose === void 0 || onAdminClose();
    createAnalyticsEvent({
      type: 'sendUIEvent',
      data: {
        source: source,
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
        attributes: {
          product: product
        },
        tags: ['fabricElements']
      }
    }).fire();
  };
  var onCTAClicked = function onCTAClicked(e) {
    e.stopPropagation();
    onAdminCTA === null || onAdminCTA === void 0 || onAdminCTA();
    createAnalyticsEvent({
      type: 'sendUIEvent',
      data: {
        source: source,
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
        attributes: {
          product: product
        },
        tags: ['fabricElements']
      }
    }).fire();
  };
  return /*#__PURE__*/React.createElement(OptInBackgroundBorder, {
    width: width,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(OptInContainer, null, image ? /*#__PURE__*/React.createElement(ImageWrapper, null, image) : /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: GlobalOptInDefaultImageBanner,
    height: "96px",
    alt: ""
  })), /*#__PURE__*/React.createElement(ContentContainer, null, isOrgAdmin && /*#__PURE__*/React.createElement(Box, {
    xcss: VisibleTextOrgAdminStyles
  }, formatMessage(messages.aiOptInAdminOnlyVisible)), /*#__PURE__*/React.createElement(HeaderWrapper, null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/React.createElement(BodyWrapper, {
    "data-testid": "dialog-body-text"
  }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: onCloseClicked,
    testId: "admin-close-button"
  }, adminCloseCTAText !== null && adminCloseCTAText !== void 0 ? adminCloseCTAText : formatMessage(messages.aiOptInDialogAdminMaybeLaterButtonText)), /*#__PURE__*/React.createElement(LinkButton, {
    appearance: "primary",
    onClick: onCTAClicked,
    href: adminLink !== null && adminLink !== void 0 ? adminLink : ADMIN_LINK,
    target: "_blank",
    testId: "admin-cta-button"
  }, adminCTAText !== null && adminCTAText !== void 0 ? adminCTAText : formatMessage(messages.aiOptInDialogAdminGetStartedButtonText))))));
};
export default AiOptIn;